import angular from 'angular';
import { AuthService } from './auth.service';

const auth = angular.module('auth', []);

auth.service('AuthService', AuthService);

export const AuthModule = auth;